export default __webpack_public_path__ + "static/media/PromoPerksLogo.dd0525d8.png";